<template>
  <o-view :has-white-background="true" :no-scroll="true">
    <o-view :bottom-padding="true">
      <o-nav-bar title="Cambio" :has-back-button="true" :is-overlay="true" />
      <o-message-header
        icon="check"
        text="Je reservatie is geannuleerd."
        :success="true"
      />
      <o-section>
        <p>
          Je reservatie werd met succes geannuleerd.
        </p>
        <p><strong>Ben je klaar met tanken?</strong></p>
      </o-section>
    </o-view>
    <o-pay-button label="Sluiten" to="/sales/car/cambio/reservations" />
  </o-view>
</template>

<script>
import OMessageHeader from '@/components/OMessageHeader.vue'
import OPayButton from '@/components/OPayButton.vue'

export default {
  name: 'CambioCancelConfirmation',
  components: {
    OMessageHeader,
    OPayButton
  },
  data() {
    return {}
  }
}
</script>

<style lang="scss"></style>
